import { action } from 'satcheljs';
import MoveToMailboxContext from '../store/schema/MoveToMailboxContext';

/**
 * Action raised once folder selection changes
 * @param context Context of folder clicked
 * @param folderId Folder Id of clicked folder
 */
export default action(
    'ON_FOLDER_CLICKED_IN_MOVEIN_CONTROL',
    (context: MoveToMailboxContext, folderId: string) => ({ context, folderId })
);
